import * as React from 'react';
import { ModalCreateContainer } from '../../containers/ModalCreateContainer';
import { ECreateFolderSource } from '../../types';
import { ModalConfirm } from '../ModalConfirm';
import { CreateFolderContainer } from '../../containers/CreateFolderContainer';
import { UIHeading2 } from '@cian/ui-kit';
import { OnBoardingDelete } from '../OnBoardingDelete';
import { ListContainer } from '../../containers/ListContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FavoritesAssignWidget(_ref) {
  var _ref$selectedIds = _ref.selectedIds,
    selectedIds = _ref$selectedIds === void 0 ? {} : _ref$selectedIds,
    _ref$isShowFoldersLis = _ref.isShowFoldersList,
    isShowFoldersList = _ref$isShowFoldersLis === void 0 ? false : _ref$isShowFoldersLis,
    isShowOnBoardingDelete = _ref.isShowOnBoardingDelete,
    isListLoading = _ref.isListLoading,
    isCreating = _ref.isCreating,
    hideCloseButton = _ref.hideCloseButton,
    children = _ref.children,
    _ref$onCreateFolder = _ref.onCreateFolder,
    onCreateFolder = _ref$onCreateFolder === void 0 ? function () {} : _ref$onCreateFolder,
    _ref$onSaveSelectedFo = _ref.onSaveSelectedFolders,
    onSaveSelectedFolders = _ref$onSaveSelectedFo === void 0 ? function () {} : _ref$onSaveSelectedFo,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
    _ref$onCloseFoldersLi = _ref.onCloseFoldersList,
    onCloseFoldersList = _ref$onCloseFoldersLi === void 0 ? function () {} : _ref$onCloseFoldersLi,
    _ref$onOpenFoldersLis = _ref.onOpenFoldersList,
    onOpenFoldersList = _ref$onOpenFoldersLis === void 0 ? function () {} : _ref$onOpenFoldersLis;
  var handleCreate = function handleCreate(name) {
    if (onCreateFolder) {
      onCreateFolder(name, ECreateFolderSource.Notification);
    }
  };
  var handleOpenChangeModal = React.useCallback(function () {
    if (onOpenFoldersList) {
      onOpenFoldersList();
    }
  }, [onOpenFoldersList]);
  var handleConfirm = React.useCallback(function () {
    if (onSaveSelectedFolders) {
      onSaveSelectedFolders();
    }
  }, [onSaveSelectedFolders]);
  var handleCloseChangeModal = React.useCallback(function () {
    if (onHide) {
      onHide();
    }
    if (onCloseFoldersList) {
      onCloseFoldersList();
    }
  }, [onCloseFoldersList, onHide]);
  var handleCreateFolder = React.useCallback(function (name) {
    if (onCreateFolder) {
      onCreateFolder(name, ECreateFolderSource.List);
    }
  }, [onCreateFolder]);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(OnBoardingDelete, {
      visible: isShowOnBoardingDelete
    }), children, /*#__PURE__*/_jsx(ModalCreateContainer, {
      onConfirm: handleCreate
    }), isShowFoldersList && /*#__PURE__*/_jsx(ModalConfirm, {
      fullScreen: hideCloseButton,
      fixed: true,
      header: /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(UIHeading2, {
            children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443"
          })
        }), /*#__PURE__*/_jsx(CreateFolderContainer, {
          onCreate: handleCreateFolder,
          isCreating: isCreating
        })]
      }),
      isVisible: true,
      isLoading: isListLoading,
      confirmButtonDisabled: !Object.keys(selectedIds).length,
      onConfirm: handleConfirm,
      onCancel: handleCloseChangeModal,
      onOpen: handleOpenChangeModal,
      children: /*#__PURE__*/_jsx(ListContainer, {})
    })]
  });
}